/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getProfileExperiments} from '../api'

 export const useQueryGetProfileExperiments = createReactQueryHook('getProfileExperiments', getProfileExperiments)
